import React from 'react';
export function RefundPolicy() {
  return <div className="w-full bg-white py-16" data-id="element-483">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-484">
        <h1 className="text-4xl font-bold text-slate-800 mb-8" data-id="element-485">
          Refund Policy
        </h1>
        <div className="prose prose-slate max-w-none" data-id="element-486">
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-487">
            Our Refund Terms
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-488">
            At Brighthands, we stand behind the quality of our repair services.
            Our refund terms are structured to be fair to both our customers and
            our business.
          </p>
          <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3" data-id="element-489">
            Refund Eligibility Periods
          </h3>
          <ul className="list-disc pl-6 text-slate-600 space-y-3 mb-6" data-id="element-490">
            <li data-id="element-491">
              <strong data-id="element-492">0-14 days:</strong> Full refund available if no repair
              work has been completed
            </li>
            <li data-id="element-493">
              <strong data-id="element-494">15-28 days:</strong> Partial refund possible at our
              discretion, depending on work completed
            </li>
            <li data-id="element-495">
              <strong data-id="element-496">After 28 days:</strong> No refund available
            </li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-497">
            Payment Processing
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-498">
            All payments are processed securely through Stripe checkout. This
            ensures your payment information is protected with industry-leading
            security standards.
          </p>
          <p className="text-slate-600 mb-6" data-id="element-499">
            Approved refunds will be returned to your original payment method
            within 14 working days of approval.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-500">
            Before Raising a Dispute
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-501">
            If you have concerns about your service or payment, please contact
            us directly before initiating any bank or card dispute. We are
            committed to resolving issues fairly and quickly.
          </p>
          <p className="text-slate-600 mb-6" data-id="element-502">
            Contact us at Sumittandon092@gmail.com or 0800 055 4969 to discuss
            any concerns.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-503">
            Non-Refundable Items
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-504">
            The following are not eligible for refund:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-505">
            <li data-id="element-506">Diagnostic callout fees once the engineer has attended</li>
            <li data-id="element-507">Completed repair work that meets service standards</li>
            <li data-id="element-508">Parts that have been fitted and approved by the customer</li>
            <li data-id="element-509">Services affected by customer misuse or third-party work</li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-510">
            How to Request a Refund
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-511">To request a refund, please:</p>
          <ol className="list-decimal pl-6 text-slate-600 space-y-2 mb-6" data-id="element-512">
            <li data-id="element-513">Contact us within the applicable timeframe</li>
            <li data-id="element-514">Provide your booking reference and order details</li>
            <li data-id="element-515">Explain the reason for your refund request</li>
            <li data-id="element-516">Allow us to investigate and respond within 5 working days</li>
          </ol>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-517">
            Contact Information
          </h2>
          <p className="text-slate-600 mb-2" data-id="element-518">
            For refund enquiries or to discuss concerns:
          </p>
          <p className="text-slate-600" data-id="element-519">
            Email: Sumittandon092@gmail.com
            <br data-id="element-520" />
            Phone: 0800 055 4969
            <br data-id="element-521" />
            Address: 5 London Rd, Portsmouth PO2 0BQ
          </p>
        </div>
      </div>
    </div>;
}